import React from "react";
import Background from "../../assets/images/pawn.png";
import { MdDesignServices } from "react-icons/md";
import { FaCode } from "react-icons/fa";
import { GiGears } from "react-icons/gi";
import { BsTools } from "react-icons/bs";
import { Link } from "react-router-dom";

function AboutMe() {
  return (
    <div className="md:px-10 xlmd:px-36 flex flex-col pb-96" id="about">
      <div className="flex justify-center">
        <h1 className="text-cool-400 font-bold text-6xl font-monts">
          About Me
        </h1>
      </div>
      <div className="flex flex-wrap xlmd:flex-nowrap xlmd:space-x-4 mt-10 justify-center items-center">
        <div
          className="flex flex-col justify-center w-[90vw] xlmd:w-[50vw] h-[70vh] md:p-8 p-3 sm:text-base  md:text-xl text-cool-400 font-monts"
          style={{
            backgroundImage: `url(${Background})`,
            backgroundPosition: "center",
            backgroundSize: "90%",
            backgroundRepeat: "no-repeat",
          }}
        >
          <p>
            I am a third year student studying Informatics and Computer Science.
          </p>

          <p className="mt-8">
            I enjoy delving into new technologies and creating creative
            solutions to the problems around me.{" "}
            <span className="block">
              Aside from this, I am constantly thinking of ways to use my
              technology skills to build innovative ways to enhance human
              connection. Check out some of my projects{" "}
              <Link
                to="/portfolio"
                className="font-semibold hover:cursor-pointer"
              >
                here
              </Link>
              .
            </span>
          </p>
          <p className="mt-8">
            I spend my free time watching and playing chess. With that said,
            feel free to reach out{" "}
            <Link to="/contact" className="font-semibold hover:cursor-pointer">
              here
            </Link>
            ; I’d love to work together (or play a game or two🧐)
          </p>
        </div>
        <div className="flex flex-col items-center justify-center bg-cool-200 mt-12 md:mt-0 pb-20 w-[90vw] xlmd:w-[50vw] min-h-[100vh] shadow-3xl">
          <div className="w-[100%]  flex flex-col justify-center items-center pt-10">
            <h1 className="text-4xl text-cool-400 font-monts font-medium">
              SKILLS
            </h1>
          </div>
          <div className=" bg-white h-[1px] w-[90%] mt-4 p-0 "></div>

          <div className="w-[100%] flex h-[100%]">
            <div
              style={{
                backgroundImage: "linear-gradient(#FFF, #FFF)",
                backgroundSize: "2px 80%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
              }}
              className="flex flex-col justify-around min-h-[100%] w-[20%] items-center"
            >
              <div className="bg-white rounded-[50%] w-[35px] h-[35px] my-9 flex items-center justify-center">
                <MdDesignServices size={25} className="fill-cool-400" />
              </div>
              <div className="bg-white rounded-[50%] w-[35px] h-[35px] my-9 flex items-center justify-center">
                <FaCode size={25} className="fill-cool-400" />
              </div>
              <div className="bg-white rounded-[50%] w-[35px] h-[35px] my-9 flex items-center justify-center">
                <GiGears size={25} className="fill-cool-400" />
              </div>
              <div className="bg-white rounded-[50%] w-[35px] h-[35px] my-9 flex items-center justify-center">
                <BsTools size={20} className="fill-cool-400" />
              </div>
            </div>
            <div className="w-[80%] h-[90%] flex flex-col gap-y-16 xlmd:gap-y-10 items-start justify-around">
              <div className="mt-10 h-24 w-[100%]">
                <div className="w-[100%]">
                  <h1 className="font-mono font-bold text-2xl text-cool-400">
                    Design
                  </h1>
                </div>
                <div className="w-[100%] h-[100%] text-cool-400 font-thin flex items-start flex-wrap pr-5 pt-3">
                  <span className="badge mb-2">Figma</span>
                  <span className="badge mb-2">Adobe Photoshop</span>
                  <span className="badge mb-2">Adobe Illustrator</span>
                </div>
              </div>
              <div className="w-[100%] h-24 mt-">
                <div className="w-[100%]">
                  <h1 className="font-mono ft font-bold text-2xl text-cool-400">
                    Front End
                  </h1>
                </div>
                <div className="w-[100%] h-[100%] flex items-start flex-wrap pr-5 pt-3 text-cool-400 font-thin">
                  <span className="badge mb-2">HTML</span>
                  <span className="badge mb-2">CSS</span>
                  <span className="badge mb-2">Javascript</span>
                </div>
              </div>
              <div className="h-24 w-[100%]">
                <div>
                  <h1 className="font-mono font-bold text-2xl text-cool-400">
                    Backend
                  </h1>
                </div>
                <div className="w-[100%] h-[100%] flex items-start flex-wrap pr-5 pt-3 text-cool-400 font-thin">
                  <span className="badge mb-2">PHP</span>
                  <span className="badge mb-2">NodeJS</span>
                </div>
              </div>
              <div className="h-24 w-[100%]">
                <div>
                  <h1 className="font-mono font-bold text-2xl text-cool-400">
                    Tools and Frameworks
                  </h1>
                </div>
                <div className="w-[100%] h-[100%] flex items-start flex-wrap pr-5 pt-3 text-cool-400 font-thin">
                  <span className="badge mb-2">VS Code</span>
                  <span className="badge mb-2">CodeIgniter</span>
                  <span className="badge mb-2">Laravel</span>
                  <span className="badge mb-2">ReactJS</span>
                  <span className="badge mb-2">NextJS</span>
                  <span className="badge mb-2">Postman</span>
                  <span className="badge mb-2">Tailwind CSS</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutMe;
